var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.5 148.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #181715;\n      }\n\n      .cls-2 {\n        fill: #1f1a18;\n      }\n\n      .cls-3 {\n        fill: #b09365;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 74.25,
    cy: 74.25,
    r: 74.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.15,
    y: 106.31,
    width: 63.33,
    height: 5.29,
    rx: 2.64,
    ry: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.06,72.85c-6.51-6.02-.02-23.03,7.29-15.97,5.94,5.74.64,23.3-7.29,15.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.77,55.86c9.57-2.89,10.46,18.19,2.05,18.72-7.92.5-8.56-16.75-2.05-18.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralFilled);
export default __webpack_public_path__ + "static/media/NeutralFilled.4da7bb94579f51223c3e455381980424.svg";
export { ForwardRef as ReactComponent };